import { render, staticRenderFns } from "./MedicPharmacy.vue?vue&type=template&id=0010f2af&scoped=true"
import script from "./MedicPharmacy.vue?vue&type=script&lang=js"
export * from "./MedicPharmacy.vue?vue&type=script&lang=js"
import style0 from "./MedicPharmacy.vue?vue&type=style&index=0&id=0010f2af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0010f2af",
  null
  
)

export default component.exports